

exports.__esModule = true;
exports.$SidebarAddBankRoute = undefined;

require('./directive');

require('components/xo-wallet-components/src/add-bank/route');

var _squid = require('squid');

var $SidebarAddBankRoute = exports.$SidebarAddBankRoute = _squid.$ComponentRoute.extend('$SidebarAddBankRoute', {

    path: 'sidebarAddBank',
    directive: 'xo-sidebar-add-bank-page',
    titleContent: 'asideHeader.addBank',
    trackingData: {
        templateName: 'tray/addBank.dust',
        pageGoal: 'Add Bank',
        buzname: {
            'fullpage': {
                'pagename': '%::add-bank',
                'pagename2': '%::add-bank:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SidebarAddBankRoute", $SidebarAddBankRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-bank/route.js
// module id = ./pages/xo-sidebar-add-bank/route.js
// module chunks = 1